import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";

export const receivableManagementRouter: RouteRecordRaw[] = [
    {
        path: "receivable",
        name: "ReceivableManagement",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/receivable/receivable",
        meta: {
            title: "应收应付"
        },
        children: [
            {
                path: "receivable",
                name: "Receivable",
                component: () => import("@/views/pages/receivableManagement/receivable/index.vue"),
                meta: {
                    title: "应收管理",
                    activeMenu: "Receivable",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        }
                    ]
                }
            },
            {
                path: "receivablesDetail",
                name: "ReceivablesDetail",
                component: () => import("@/views/pages/receivableManagement/receivable/detail.vue"),
                meta: {
                    title: "应收款详情",
                    activeMenu: "Receivable",
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        }
                    ]
                }
            },
            {
                path: "payAbles",
                name: "PayAbles",
                component: () => import("@/views/pages/receivableManagement/payAbles/index.vue"),
                meta: {
                    title: "应付管理",
                    activeMenu: "PayAbles",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        }
                    ]
                }
            },
            {
                path: "payAblesDetail",
                name: "PayAblesDetail",
                component: () => import("@/views/pages/receivableManagement/payAbles/detail.vue"),
                meta: {
                    title: "应付款详情",
                    activeMenu: "PayAbles",
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        }
                    ]
                }
            }
        ]
    }
];

export default receivableManagementRouter;
